var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{class:_vm.noPadding ? '' : "pl-4 pr-4",attrs:{"align":_vm.align,"align-content":_vm.alignContent}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }